export default "__VITE_ASSET__DcmBbZRG__"